import React, { Component } from 'react'
import Scroll from 'react-scroll'
import config from '../config.json'
import Slide from './Slide'
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails.jsx'
import getMovieLink from '../functions/getMovieLink'
import { KENBURNS, KENBURNSPOSTERCENTER, KENBURNSPOSTERRIGHT } from '../constants/selectionStylingTypes'
import SlideActiveItem from '../SliderGeneral/SlideActiveItem'
import { MAINSLIDER, SLIDER } from '../constants/selectionTypes.jsx'
import getSliderAppearanceClass from '../functions/getSliderAppearanceClass.js'
const breakpoints = config.breakpoints

let Element = Scroll.Element
let scroll = Scroll.animateScroll;

class SliderBasic extends Component {
    constructor(props) {
        super(props)

        this.state = {
            currentDateActive: ''
        }

        this.toggleMovieDatesOnMobileView = this.toggleMovieDatesOnMobileView.bind(this)
    }

    toggleMovieDatesOnMobileView(date) {        
        this.setState({
            currentDateActive: date
        })
    }

    componentDidUpdate(prevProps) {
        const {currentActiveSelection, selectionId, activeItem, onCloseInformation} = this.props
        if (currentActiveSelection !== prevProps.currentActiveSelection) {
            if(currentActiveSelection && currentActiveSelection !== selectionId && activeItem) {
                onCloseInformation()
            }
        }
    }

    getEventOrigins() {
        const { isMainSlider, sliderTitle='' } = this.props
        const eventOriginTitle = isMainSlider ? 'Kino Highlights' : sliderTitle

        return {
            slide:                  'Startseite, Slider "' + eventOriginTitle + '", Posterelement',
            information:            'Startseite, Slider "' + eventOriginTitle + '", Film Information',
            informationSlidebar:    'Startseite, Slider "' + eventOriginTitle + '", Film Imformation/rechte Slidebar',
            performance:            'Startseite, Slider "' + eventOriginTitle + '", Film Vorführung',
            performanceSlidebar:    'Startseite, Slider "' + eventOriginTitle + '", Film Vorführung/rechte Slidebar',
            details:                'Startseite, Slider "' + eventOriginTitle + '", Film Details',
            detailsSlidebar:        'Startseite, Slider "' + eventOriginTitle + '", Film Details/rechte Slidebar'
        }
    }

    render() {
        const { 
            items, 
            moviesData, 
            activeDetailsItem,
            adsData, 
            advertisementsData,
            weischerAdsData,
            elbenwald,
            scrollToPosition, 
            settings, 
            displaySidebarRight, 
            displaySidebarRightSecond, 
            mainSliderAdvertisementPositioning,
            sliderTitle='',
            backgroundVisualsSettings,
            theme, 
            attributeStyling,
            translation,
            isConnectedFast,
            moviesRoutesData,
            informationStyling,
            detailsStyling,
            sliderAppearance,
            activeItem,  
            filterType,
            type,
            hiddenAttributes,
            isMobile,
            filterValue,
            canParallax,
            ignoreAttributesForPerformanceFilter,
            activePerformance, 
            performancePageOpen,
            onCloseDetails,
            onOpenDetails,
            showAvailableIn,
            onOpenPerformancePage,
            onClosePerformancePage,
            onCloseInformation,
            onOpenInformation,
            smallSliderAppearance,
            features=null
        } = this.props

        const { 
            currentDateActive
        } = this.state

        const eventOrigins = this.getEventOrigins()
        const itemLink = getMovieLink(activeItem, moviesRoutesData, translation)
        const detailsOpen = activeDetailsItem === activeItem
        const sliderFadeClass =
            (backgroundVisualsSettings.style === KENBURNS ||
            backgroundVisualsSettings.style === KENBURNSPOSTERCENTER ||
            backgroundVisualsSettings.style === KENBURNSPOSTERRIGHT) ||
            backgroundVisualsSettings.trailerAutoplay
            ? ' slider-fade-element'
            : '';
        const sliderAppearanceClassForType = type === MAINSLIDER ? ' ' + sliderAppearance : type === SLIDER ? ' ' + smallSliderAppearance : ''
        const sliderAppearanceClass = getSliderAppearanceClass(sliderAppearance)

        return (
            <div className={"slider-wrapper " + scrollToPosition + sliderFadeClass + sliderAppearanceClass + sliderAppearanceClassForType}>
                <Element name={scrollToPosition}></Element>

                <Slide
                    sliderTitle={sliderTitle}
                    backgroundVisualsSettings={backgroundVisualsSettings}
                    mainSliderAdvertisementPositioning={mainSliderAdvertisementPositioning}
                    features={features}
                    items={items}
                    sliderType={type}
                    showAvailableIn={showAvailableIn}
                    theme={theme}
                    attributeStyling={attributeStyling}
                    canParallax={canParallax}
                    hiddenAttributes={hiddenAttributes}
                    translation={translation}
                    moviesData={moviesData}
                    adsData={adsData}
                    advertisementsData={advertisementsData}
                    weischerAdsData={weischerAdsData}
                    settings={settings}
                    eventOrigins={eventOrigins}
                    isConnectedFast={isConnectedFast}
                    scrollToPosition={scrollToPosition}
                    onClickSlideItem={onOpenInformation}
                />
            
                <a onClick={() => scroll.scrollTo(550)} className={'scrolldown-button-phone'}></a>

                <SlideActiveItem
                    itemLink={itemLink}
                    activeItem={activeItem}
                    activePerformance={activePerformance}
                    currentDateActive={currentDateActive}
                    isMobile={isMobile}
                    ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                    theme={theme}
                    filterValue={filterValue}
                    filterType={filterType}   
                    hiddenAttributes={hiddenAttributes}
                    scrollToPosition={scrollToPosition}
                    eventOrigins={eventOrigins}
                    moviesData={moviesData}
                    elbenwald={elbenwald}
                    translation={translation}
                    detailsStyling={detailsStyling}
                    informationStyling={informationStyling}
                    attributeStyling={attributeStyling}
                    displaySidebarRight={displaySidebarRight}
                    displaySidebarRightSecond={displaySidebarRightSecond}
                    performancePageOpen={performancePageOpen}
                    detailsOpen={detailsOpen}
                    onCloseInformation={onCloseInformation}
                    onOpenDetails={onOpenDetails}
                    onCloseDetails={onCloseDetails}
                    onOpenPerformancePage={onOpenPerformancePage}
                    onClosePerformancePage={onClosePerformancePage}
                    toggleMovieDatesOnMobileView={this.toggleMovieDatesOnMobileView}
                />
            </div>
        )
    }
}

export default hasSlidebarRightAndSecond({breakpoint:  breakpoints.slidebarRight})(hasOpenInformationAndDetails(SliderBasic))